<header class="main__content__header modal-header">
    <h2 class="modal-title">Aviso!</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="main__content__modal modal-body" >
    <p>Prezado, seu acesso para o formulário de Plano Demissional Voluntário (PDV) será liberado após confirmado o desligamento da Patrocinadora!</p>
</main>

<footer class="modal-footer">
    <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1"
        (click)="activeModal.close(true)">
        <div>
            <span>Ok</span>
        </div>
    </button>
</footer>